const BLACKLIST = [
  '/confirmar-dados'
];

export function getPreviousUrl() {
  return window.localStorage.getItem('currentUrl')
}

export function setPreviousUrl (url) {
  if (!BLACKLIST.includes(url)) {
    window.localStorage.setItem('currentUrl', url)
  }
}

export function redirectToPreviousUrl () {
  window.location.href = getPreviousUrl() || '/'
}